module.exports = __webpack_public_path__ + "static/stay-cool-f71b2c5b91db6e6c9ed42c201e3944d3.png";